(function () {
  function initFaq(root) {
    root.querySelectorAll('.faq-item').forEach((item) => {
      const btn = item.querySelector('.faq-question');
      if (!btn || btn.dataset.faqBound) return;
      btn.dataset.faqBound = 'true';

      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        root.querySelectorAll('.faq-item.is-open').forEach((open) => {
          if (open !== item) open.classList.remove('is-open');
        });
        item.classList.toggle('is-open', !isOpen);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFaq(document));
  } else {
    initFaq(document);
  }
})();
